import { useQuery } from '@tanstack/react-query';
import { ApyReturnsLookup } from 'src/@types/vaults';
import { ENABLE_STRATEGY_VAULTS } from 'src/constants/featureGates';
import { VAULT_REFETCH_INTERVAL } from '../consts';
import { vaultQueryKeys } from '../vaultQueryKeys';

async function fetchVaultApyReturns(): Promise<ApyReturnsLookup> {
	const res = await fetch('/api/vaults');
	if (!res.ok) {
		throw new Error('Failed to fetch vault APY returns');
	}
	return res.json();
}

export function useVaultApyReturns() {
	return useQuery({
		queryKey: vaultQueryKeys.vaultApyReturns(),
		queryFn: fetchVaultApyReturns,
		enabled: ENABLE_STRATEGY_VAULTS,
		staleTime: VAULT_REFETCH_INTERVAL,
		refetchInterval: VAULT_REFETCH_INTERVAL,
	});
}
